import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import IconRecoverableError from '../../components/Icons/IconRecoverableError';
import PageHeader from '../../components/PageHeader';
import { recoverableErrorTypes } from '../../reducers/propTypes';

export const ErrorPage = ({ recoverableError }) => {
  const history = useHistory();

  const { data } = recoverableError;
  const { errorMessage } = data || {};
  const title =
    errorMessage.length > 1 ? "Oops! We've spotted some errors." : "Oops! We've spotted an error.";

  const guidance =
    errorMessage.length > 1
      ? 'Seems like there were some mistakes somewhere in the application. Have a look at the errors and make the necessary changes to continue on to getting your quote!'
      : 'Seems like there was a mistake somewhere in the application. Have a look at the error and make the necessary changes to continue on to getting your quote!';

  return (
    <div className="container container--space-y">
      <PageHeader
        title={`${title} Please make changes to keep going.`}
        action={() => history.goBack()}
      />

      <div className="row row--align-middle-small row--align-center">
        <div className="col col--10/16-small">
          <div className="row-spacer">{guidance}</div>

          {errorMessage && (
            <div className="row-spacer">
              <ul>
                {errorMessage.map((message, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <li key={`message-${index}`}>
                    <b>{message}</b>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="col col--6/16-small col--4/16-medium col--3/16-large col--align-right-small block--small">
          <IconRecoverableError />
        </div>
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  recoverableError: recoverableErrorTypes,
};

ErrorPage.defaultProps = {
  recoverableError: {},
};

export const mapStateToProps = state => ({
  recoverableError: state.recoverableError,
});

export default connect(mapStateToProps)(ErrorPage);
